import type { Thunk, Action } from 'easy-peasy';
import { action, thunk } from 'easy-peasy';
import type { Injections } from '../../services/injections';
import type { ApplicationErrorOptions } from '../../../types';
import type { FetchCarrierShipmentLaneConfigurationsParams } from '../types';
import parseStatusCode from '../../errors/parseStatusCode';
import type { PartnerLaneOrchestration } from '@shipium-corp/shipium-ts-types';

export interface ShipmentLaneModel {
  fetchShipmentLanes: Thunk<
    ShipmentLaneModel,
    FetchCarrierShipmentLaneConfigurationsParams,
    Injections,
    Promise<PartnerLaneOrchestration[]>
  >;
  shipmentLaneStart: Action<ShipmentLaneModel, void>;
  lastAction?: number;
  fetchShipmentLanesLoading: boolean;
  shipmentLanes: Record<string, PartnerLaneOrchestration>;
  shipmentLaneFailure: Action<ShipmentLaneModel, ApplicationErrorOptions>;
  setShipmentLanes: Action<ShipmentLaneModel, PartnerLaneOrchestration[]>;
}

export const shipmentLanesModel: ShipmentLaneModel = {
  shipmentLanes: {},
  shipmentLaneFailure: action((state, payload) => {
    console.error(payload);
  }),
  setShipmentLanes: action((state, payload) => {
    for (const val of payload) {
      state.shipmentLanes[val.laneId as string] = val;
    }
  }),
  fetchShipmentLanesLoading: false,
  shipmentLaneStart: action((state, payload) => {
    state.lastAction = Date.now();
  }),
  fetchShipmentLanes: thunk(async (actions, payload, { injections }) => {
    try {
      actions.shipmentLaneStart();
      const res = await injections.assetService.fetchShipmentLanes(payload);
      actions.setShipmentLanes(res);
      return res;
    } catch (error) {
      actions.shipmentLaneFailure({
        error,
        httpCode: parseStatusCode(error),
        message: 'An error occured fetching shipment lanes',
        asNotification: true,
      });
    }
  }),
};
